import { Button } from '@cof/plastic-components';
import { css, styled } from 'styled-components';
import { space } from 'styled-system';

const LinkButton = styled(Button).attrs(() => ({ 'variant': 'textLinkInline', 'data-qm-allow': true }))`
    ${({ theme }: any) => css`
        font-weight: 600;
        display: block;
        margin: 0;
        ${space}
        ${({ $isError }: any) => ($isError ? theme.components.helperText.error : '')};
        &:empty {
            display: none;
        }
    `}
`;
LinkButton.displayName = 'LinkButton';

export default LinkButton;
